module.exports = __webpack_public_path__ + "static/img/ic_charge@2x.0203e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_charge@2x.png
// module id = rAys
// module chunks = 1